export const liabilityTitleText = type =>
  `${type.charAt(0).toUpperCase() + type.substring(1)} loan`;

export const liabilityKey = liability => {
  const { id = '', liabilityType, currency, amount, term, rate } = liability;
  return `${id}${liabilityType}-${currency}-${amount}-${term}-${rate}`;
};
